import React, { PureComponent } from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import styled from 'styled-components';
import ComponentTitle from './ComponentTitle';
import UpdatedDate from './UpdatedDate';
import SortAscendingIcon from './assets/SortAscendingIcon.svg';
import SortDescendingIcon from './assets/SortDescendingIcon.svg';

const StyledAlertTableComponent = styled.div`
  grid-column: span 12;
  @media (min-width: 1280px) {
    grid-column: span ${props => props.columns};
  }
`;

const TableWrapper = styled.div`
  padding: 5px 10px 10px 10px;
  border-radius: 5px;
  position: relative;
  background: white;
  box-shadow: 0 2px 4px 0 rgba(38, 47, 51, 0.3);
  overflow: hidden;
  border-top: 5px solid #ff215d;
  .ReactTable {
    color: #262f33;
    border: 0;
    font-size: 13px;
    .rt-thead {
      font-family: latoblack;
      &.-header {
        box-shadow: none;
        padding-top: 10px;
        padding-bottom: 10px;
        color: #828282;
      }
      .rt-th {
        text-align: left;
        font-size: 13px;
        border-right-color: #6d7b80;
        padding: 5px 21px 5px 10px;
        background-repeat: no-repeat;
        background-position: calc(100% - 5px) center;
        &.type-number {
          text-align: right;
        }
        &.-sort-asc {
          box-shadow: none;
          background-image: url(${props => props.sortDescendingIconUrl});
        }
        &.-sort-desc {
          box-shadow: none;
          background-image: url(${props => props.sortAscendingIconUrl});
        }
      }
    }
    .rt-tbody {
      font-family: latoregular;
      .rt-tr {
        &.-even {
          background-color: #ffffff;
        }
        &.-odd {
          background-color: #f0f2f2;
        }
      }
      .rt-tr-group {
        border-bottom: 0;
      }
      .rt-td {
        text-align: left;
        border-right: 0;
        padding: 15px 21px 15px 10px;
        &.type-number {
          text-align: right;
        }
        &.type-percent {
          text-align: right;
        }
      }
    }
    .rt-tfoot {
      font-family: latoblack;
      .rt-tr {
        box-shadow: none;
        padding-top: 10px;
        padding-bottom: 10px;
        border-top: 1px solid #6d7b80;
      }
      .rt-td {
        text-align: left;
        font-size: 13px;
        border-right-color: #6d7b80;
        padding: 5px 21px 5px 10px;
        background-repeat: no-repeat;
        background-position: calc(100% - 5px) center;
        &.type-number {
          text-align: right;
        }
      }
    }
    .-pagination {
      box-shadow: none;
      -webkit-box-shadow: none;
      padding: 6px;
      .-btn {
        background: none;
      }
    }
  }
`;

/*
[{"Datum":"30.9.2018","Hinweis":"Mehr Kundenwechsel durch Mittbewerber im September als erwartet","Beobachtung (Referenz)": "-1,2% (-0,5% bis -0,9%)","Aktion":"Verwerfen / Ansehen "},
{"Datum":"30.9.2018","Hinweis":"Mehr Kundenwechsel Online Tarife im September als erwartet","Beobachtung (Referenz)": "-1,1% (-0,5% bis -0,9%)","Aktion":"Verwerfen / Ansehen "},
{"Datum":"30.9.2018","Hinweis":"Mehr Neukunden Öko Premium im September als erwartet","Beobachtung (Referenz)": "+2,2% (+0,4% bis +0,9%)","Aktion":"Verwerfen / Ansehen "},
{"Datum":"30.9.2018","Hinweis":"Neuer Risikofaktor für Wechsler ermittelt","Beobachtung (Referenz)": "N/A","Aktion":"Verwerfen / Ansehen "}]


*/
class AlertTableComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
    this.defaultSortMethod = this.defaultSortMethod.bind(this);
  }

  betterValueOf(value) {
    let betterValue = value;
    (value === null || value === undefined || value === '-') &&
      (betterValue = -Infinity);

    let valueAsNumber = parseFloat(
      !isNaN(betterValue)
        ? betterValue // If it's a number, parse it into one
        : betterValue.replace(/\s|%/g, '').replace(/,/, '.') // Otherwise, give it another change after transform
    );

    !isNaN(valueAsNumber) && (betterValue = valueAsNumber);

    return betterValue;
  }

  defaultSortMethod(a, b, desc) {
    // force null and undefined to the bottom
    a = a === null || a === undefined || a === '-' ? -Infinity : a;
    b = b === null || b === undefined || b === '-' ? -Infinity : b;

    // force any string values to lowercase
    a = typeof a === 'string' ? a.toLowerCase() : a;
    b = typeof b === 'string' ? b.toLowerCase() : b;

    a = this.betterValueOf(a);
    b = this.betterValueOf(b);

    // Return either 1 or -1 to indicate a sort priority
    if (a > b) {
      return 1;
    }
    if (a < b) {
      return -1;
    }
    // returning 0 or undefined will use any subsequent column sorting methods or the row index as a tiebreaker
    return 0;
  }

  render() {
    const { title, info } = this.props;
    const data = JSON.parse(this.props.data);
    const translations = {
      previousText: '<',
      nextText: '>',
      loadingText: 'Laden...',
      noDataText: 'Leer',
      pageText: '',
      ofText: '/',
      rowsText: 'Zeilen'
    };
    return (
      <StyledAlertTableComponent columns={this.props.columns}>
        <ComponentTitle title={title} info={info} />
        <TableWrapper
          sortAscendingIconUrl={SortAscendingIcon}
          sortDescendingIconUrl={SortDescendingIcon}
        >
          <ReactTable
            {...translations}
            data={data}
            columns={[
              {
                Header: 'Datum',
                accessor: 'Datum'
              },
              {
                Header: 'Hinweis',
                accessor: 'Hinweis',
                minWidth: 300,
                Cell: row => (
                  <span>
                    <span
                      style={{
                        backgroundColor: '#ffa138',
                        borderRadius: '50%',
                        content: '!',
                        width: '20px',
                        height: '20px',
                        display: 'inline-block',
                        lineHeight: '20px',
                        textAlign: 'center',
                        paddingLeft: '1px',
                        marginRight: '6px'
                      }}
                    >
                      !
                    </span>
                    {row.value}
                  </span>
                )
              },
              {
                Header: 'Beobachtung (Referenz)',
                accessor: 'Beobachtung (Referenz)',
                Cell: row => (
                  <span
                    style={{
                      backgroundColor:
                        (row.value.charAt(0) === '-') |
                        !isNaN(row.value.charAt(0))
                          ? '#fd91a9'
                          : row.value.charAt(0) === '+'
                            ? '#d0e385'
                            : '',
                      transition: 'all .3s ease',
                      borderRadius: '5px',
                      padding: '3px 8px'
                    }}
                  >
                    {row.value}
                  </span>
                )
              },
              {
                Header: 'Aktion',
                accessor: 'Aktion',
                Cell: row => (
                  <div
                    style={{
                      marginTop: '-5px'
                    }}
                  >
                    {/* <a href={row.value}>
                      <div
                        style={{
                          display: 'inline-block',
                          color: 'rgb(66, 188, 218)',
                          backgroundColor: 'none',
                          border: '1px solid rgb(66, 188, 218)',
                          fontSize: '1em',
                          padding: '0.3em 0.7em',
                          borderRadius: '5px',
                          cursor: 'pointer'
                        }}
                      >
                        Bestätigen
                      </div>
                    </a>{' '} */}
                    {row.value == '-' ? (
                      '-'
                    ) : (
                      <a href={row.value}>
                        <div
                          style={{
                            display: 'inline-block',
                            color: 'white',
                            backgroundColor: 'rgb(66, 188, 218)',
                            border: '1px solid rgb(66, 188, 218)',
                            fontSize: '1em',
                            padding: '0.3em 0.7em',
                            borderRadius: '5px',
                            cursor: 'pointer'
                          }}
                        >
                          Ansehen
                        </div>
                      </a>
                    )}
                  </div>
                )
              }
            ]}
            showPagination={true}
            defaultPageSize={5}
            showPageSizeOptions={false}
            pageSizeOptions={[5, 20, 100]}
            minRows={0}
          />
          <br />
          <UpdatedDate>{`letztes Update: ${
            this.props.lastUpdated
          }`}</UpdatedDate>
        </TableWrapper>
      </StyledAlertTableComponent>
    );
  }
}

export default AlertTableComponent;
